<div class="content-section" *ngIf="content$ | async as data; else loadingTpl">
  <ng-container *ngIf="data['Conoce-mas-sobre-la-reforma']?.beneficios?.['ampliacion-seguro'] as asl">
    <p class="description" [innerHTML]="asl.description"></p>

    <div class="access-section">
      <h3>{{ asl.accessTitle }}</h3>
      <p>{{ asl.accessText }}</p>
    </div>

    <div class="information-cards">
      <article class="information-card">
        <icon-ampliacion-seguro-persona aria-hidden="true"></icon-ampliacion-seguro-persona>
        <h4>¿Quiénes acceden?</h4>
        <p>{{ asl.card1Text }}</p>
      </article>

      <article class="information-card">
        <icon-ampliacion-seguro-documento aria-hidden="true"></icon-ampliacion-seguro-documento>
        <h4>¿Cómo se accede?</h4>
        <p>{{ asl.card2Text }}</p>
      </article>

      <article class="information-card">
        <icon-ampliacion-seguro-alcancia aria-hidden="true"></icon-ampliacion-seguro-alcancia>
        <h4>¿Qué cubre?</h4>
        <p>{{ asl.card3Text }}</p>
      </article>
    </div>

    <div class="benefits-box">
      <h3>{{ asl.benefitsTitle }}</h3>
      <p>{{ asl.benefitsText }}</p>
    </div>
  </ng-container>
</div>

<ng-template #loadingTpl>
  <app-text-skeleton [lines]="6"></app-text-skeleton>
</ng-template>